export default function GifShowcase({
	title,
	description,
	gif,
	objectFit,
}) {
	return (
		<div className="gifShowcase">
			<div>
				<div className="gifInformationContent">
					<h2>{title}</h2>
					<p>{description}</p>
				</div>
				<img src={gif} alt={title} style={{ objectFit }} />
			</div>
		</div>
	);
}
